module.exports = __webpack_public_path__ + "static/media/affinity_new.6b7e22da.png";